export default "__VITE_ASSET__STeLiu1i__"